import { ColumnActionsMode } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import {
  centerAlignHeaderStyle,
  commonColumnProps,
} from 'common/utils/columnUtilities';

export const getColumns = () => {
  const columns: ColumnData[] = [
    {
      key: 'name',
      name: 'Group',
      fieldName: 'name',
      minWidth: 180,
      maxWidth: 180,
      ...commonColumnProps,
    },
    {
      key: 'description',
      name: 'Description',
      fieldName: 'description',
      minWidth: 280,
      maxWidth: 280,
      ...commonColumnProps,
    },
    {
      key: 'workgroupGroupItems',
      name: 'Workgroups',
      fieldName: 'workgroupGroupItems',
      minWidth: 750,
      maxWidth: 750,
      ...commonColumnProps,
    },
    {
      key: 'action',
      name: 'Action',
      fieldName: 'action',
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      styles: centerAlignHeaderStyle,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
    },
  ];
  return columns;
};
